import { Box, Typography, makeStyles } from "@material-ui/core";

type Props = {
  title: string;
  children: React.ReactNode;
};

export default function DetailSection({ title, children }: Props) {
  const classes = useStyles();

  return (
    <Box marginBottom={2.5}>
      <Typography className={classes.title}>{title}</Typography>
      {children}
    </Box>
  );
}

const useStyles = makeStyles({
  title: {
    color: "grey",
    fontSize: "0.75rem",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginBottom: 8,
  },
});
